import * as React from "react";
import * as __ from "lodash";
import {Icon, Button} from "@material-ui/core"

export default class MaterialTableButtonBar extends React.Component {

  constructor() {
    super();

    this.editing = false;
    this.selectedRecord = null;
    this.height = 36;
    this.buttons = {};
    this.mode = null;
  }

  buttonHandler(buttonPressed) {
    switch (buttonPressed) {
      case "add":
        this.props.manager.dataManager.changeRowEditing();
        this.props.manager.setState({
          ...this.props.manager.dataManager.getRenderState(),
          showAddRow: !this.props.manager.state.showAddRow,
        });
        this.editing = true;
        break;
      case "edit":
        this.props.manager.dataManager.changeRowEditing(this.props.row, "update");
        this.props.manager.setState({
          ...this.props.manager.dataManager.getRenderState(),
          showAddRow: false,
        });
        break;
      case "delete":
        this.props.manager.dataManager.changeRowEditing(this.props.row, "delete");
        this.props.manager.setState({
          ...this.props.manager.dataManager.getRenderState(),
          showAddRow: false,
        });
        break;
      case "cancel":
        this.props.manager.onEditingCanceled(this.mode, this.props.row);
        break;
      case "save":
        this.props.manager.onEditingApproved(this.mode, this.props.editedRowData||this.props.originalRowData||this.props.row, this.props.originalRowData||this.props.row);
        break;
      default: 
        break;
    }
    // if (buttonPressed === "cancel") {
    //   onChange({buttonPressed, record: props.record, oldRecord: props.record, formRef});
    //   setRecord(props.record);
    // } else {
    //   onChange({buttonPressed, record, oldRecord: props.record, formRef});
    // }
  }

  updateProperties(){
    const userButtons = typeof this.props.buttons === "function"?this.props.buttons({record: this.selectedRecord, editing: this.props.editing }):this.props.buttons||{};
    const {save: saveButton, cancel: cancelButton, add: addButton, edit: editButton, delete: deleteButton, ...otherButtons} = userButtons||{};

    const defaultButtons = {};
    if (this.props.editing) {
      defaultButtons['save'] = {
        icon: "check_circle", 
        key: "Save", 
        label: "Save", 
        color: "primary",
        ...saveButton
      };
      defaultButtons['cancel'] = {
        icon: "cancel", 
        key: "Cancel", 
        label: "Cancel", 
        color: "primary",
        ...cancelButton
      };
    } else {
      if (this.props?.manager?.props?.editable) {
        if (this.props.manager.props.editable.onRowAdd) {
          defaultButtons['add'] = {
            icon: "add", 
            key: "New", 
            label: "Add", 
            color: "primary", 
            disabled: !!this.props.manager.dataManager.lastEditingRow,
            ...addButton
          };
        }
        if (this.props.manager.props.editable.onRowUpdate) {
          defaultButtons['edit'] = {
            icon: "edit", 
            key: "Edit", 
            label: "Edit", 
            color: "primary", 
            disabled: !this.props.row || (this.props.manager.props.editable.isEditable && !this.props.manager.props.editable.isEditable(this.props.row)),
            hidden: this.props.manager.props.editable.isEditHidden && this.props.manager.props.editable.isEditHidden(this.props.row),
            ...editButton
          };
        }
        if (this.props.manager.props.editable.onRowDelete) {
          defaultButtons['delete'] = {
            icon: "delete", 
            key: "Delete", 
            label: "Delete", 
            color: "primary", 
            disabled: !this.props.row || (this.props.manager.props.editable.isDeletable && !this.props.manager.props.editable.isDeletable(this.props.row)),
            hidden: this.props.manager.props.editable.isDeleteHidden && this.props.manager.props.editable.isDeleteHidden(this.props.row),
            ...deleteButton
          };
        }
      }
    }
    this.buttons = {
      ...defaultButtons,
      ...otherButtons
    }
    if (this.props.height) {
      this.height = this.props.height;
    }
    this.mode = (this.props.row && this.props.row.tableData && this.props.row.tableData.editing) ? this.props.row.tableData.editing :this.props.mode;
  }

  render() {
    this.updateProperties();

    if (typeof this.buttons === "object" && Object.entries(this.buttons).length > 0) {
      return (
        <div style={{
          height: this.height,
          borderTop: (__.isEmpty(this.buttons) ? "" : "1px solid grey"),
          marginLeft: -20,
          width: "100%",
          textAlign: "right",
          background: "#ffffff",
          ...this.props.buttonBarStyle
        }}>
          {
            Object.entries(this.buttons).map(([key, buttonProps]) => {
              const button = __.omit(buttonProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon']);
              const iconOptions = {color:"primary", ...this.props.iconOptions};
              button['onClick'] = ()=>this.buttonHandler(key);
              if (typeof buttonProps.hidden === "function") {
                button['hidden'] = buttonProps.hidden({record: this.selectedRecord, editing: this.props.editing});
              } else {
                button['hidden'] = buttonProps.hidden;
              }
              if (typeof buttonProps.disabled === "function") {
                button['disabled'] = buttonProps.disabled({record: this.selectedRecord, editing: this.props.editing});
              } else {
                button['disabled'] = buttonProps.disabled;
              }
              iconOptions['hidden'] = button.hidden;
              iconOptions['disabled'] = button.disabled;
              if (iconOptions.disabled) {
                iconOptions['color']=undefined;
              }
  
              if (buttonProps.icon) {
                button['startIcon'] = (<Icon {...iconOptions}>{buttonProps.icon}</Icon>);
              }
  
              return (
                <Button {...button}>
                  {buttonProps.label}
                </Button>
              )
            })
          }
        </div>
      )
    }
    return null;
  }
}